var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/status-media.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { openModal } from 'soapbox/actions/modals';
import AttachmentThumbs from 'soapbox/components/attachment-thumbs';
import PlaceholderCard from 'soapbox/features/placeholder/components/placeholder-card';
import Card from 'soapbox/features/status/components/card';
import Bundle from 'soapbox/features/ui/components/bundle';
import { MediaGallery, Video, Audio } from 'soapbox/features/ui/util/async-components';
import { useAppDispatch, useSettings } from 'soapbox/hooks';
import { addAutoPlay } from 'soapbox/utils/media';

/** Render media attachments for a status. */
const StatusMedia = _ref => {
  let {
    status,
    muted = false,
    onClick,
    showMedia = true,
    onToggleVisibility = () => {}
  } = _ref;
  const dispatch = useAppDispatch();
  const settings = useSettings();
  const shouldAutoPlayVideo = settings.get('autoPlayVideo');
  const [mediaWrapperWidth, setMediaWrapperWidth] = useState(undefined);
  const size = status.media_attachments.size;
  const firstAttachment = status.media_attachments.first();
  let media = null;

  const setRef = c => {
    if (c) {
      setMediaWrapperWidth(c.offsetWidth);
    }
  };

  const renderLoadingMediaGallery = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "media_gallery",
      style: {
        height: '285px'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 12
      }
    });
  };

  const renderLoadingVideoPlayer = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "media-spoiler-video",
      style: {
        height: '285px'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 12
      }
    });
  };

  const renderLoadingAudioPlayer = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "media-spoiler-audio",
      style: {
        height: '285px'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 12
      }
    });
  };

  const openMedia = (media, index) => {
    dispatch(openModal('MEDIA', {
      media,
      status,
      index
    }));
  };

  if (size > 0 && firstAttachment) {
    if (muted) {
      media = /*#__PURE__*/React.createElement(AttachmentThumbs, {
        media: status.media_attachments,
        onClick: onClick,
        sensitive: status.sensitive,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 73,
          columnNumber: 9
        }
      });
    } else if (size === 1 && firstAttachment.type === 'video') {
      const video = firstAttachment;

      if (video.external_video_id && status.card) {
        const getHeight = () => {
          const width = Number(video.meta.getIn(['original', 'width']));
          const height = Number(video.meta.getIn(['original', 'height']));
          return Number(mediaWrapperWidth) / (width / height);
        };

        const height = getHeight();
        media = /*#__PURE__*/React.createElement("div", {
          className: "status-card horizontal compact interactive status-card--video",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 92,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement("div", {
          ref: setRef,
          className: "status-card__image status-card-video",
          style: height ? {
            height
          } : undefined,
          dangerouslySetInnerHTML: {
            __html: shouldAutoPlayVideo ? addAutoPlay(status.card.html) : status.card.html
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 93,
            columnNumber: 13
          }
        }));
      } else {
        media = /*#__PURE__*/React.createElement(Bundle, {
          fetchComponent: Video,
          loading: renderLoadingVideoPlayer,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 105,
            columnNumber: 11
          }
        }, Component => /*#__PURE__*/React.createElement(Component, {
          preview: video.preview_url,
          blurhash: video.blurhash,
          src: video.url,
          alt: video.description,
          aspectRatio: Number(video.meta.getIn(['original', 'aspect'])),
          height: 285,
          visible: showMedia,
          inline: true,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 107,
            columnNumber: 15
          }
        }));
      }
    } else if (size === 1 && firstAttachment.type === 'audio') {
      const attachment = firstAttachment;
      media = /*#__PURE__*/React.createElement(Bundle, {
        fetchComponent: Audio,
        loading: renderLoadingAudioPlayer,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125,
          columnNumber: 9
        }
      }, Component => /*#__PURE__*/React.createElement(Component, {
        src: attachment.url,
        alt: attachment.description,
        poster: attachment.preview_url !== attachment.url ? attachment.preview_url : status.getIn(['account', 'avatar_static']),
        backgroundColor: attachment.meta.getIn(['colors', 'background']),
        foregroundColor: attachment.meta.getIn(['colors', 'foreground']),
        accentColor: attachment.meta.getIn(['colors', 'accent']),
        duration: attachment.meta.getIn(['original', 'duration'], 0),
        height: 263,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 127,
          columnNumber: 13
        }
      }));
    } else {
      media = /*#__PURE__*/React.createElement(Bundle, {
        fetchComponent: MediaGallery,
        loading: renderLoadingMediaGallery,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 142,
          columnNumber: 9
        }
      }, Component => /*#__PURE__*/React.createElement(Component, {
        media: status.media_attachments,
        sensitive: status.sensitive,
        height: 285,
        onOpenMedia: openMedia,
        visible: showMedia,
        onToggleVisibility: onToggleVisibility,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 144,
          columnNumber: 13
        }
      }));
    }
  } else if (status.spoiler_text.length === 0 && !status.quote && status.card) {
    media = /*#__PURE__*/React.createElement(Card, {
      onOpenMedia: openMedia,
      card: status.card,
      compact: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 158,
        columnNumber: 7
      }
    });
  } else if (status.expectsCard) {
    media = /*#__PURE__*/React.createElement(PlaceholderCard, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 166,
        columnNumber: 7
      }
    });
  }

  if (media) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      React.createElement("div", {
        onClick: e => e.stopPropagation(),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 173,
          columnNumber: 7
        }
      }, media)
    );
  } else {
    return null;
  }
};

export default StatusMedia;